<template lang="pug">
    v-container( fluid fill-height pa-0 class="overflow-hidden align-start grey lighten-4 mb-10s" )
        v-row(no-gutters)
            v-col
                v-row(no-gutters class="tw-bg-blue-800 tw-rounded-t py-2 pl-2")
                    v-col
                        span(class="white--text tw-font-medium ") Create Contact
                v-row(no-gutters  class=" fill-height grey lighten-4 tw-shadow-inner")
                    v-col(class="pa-2 mt-2" id="createOpportunity")
                        v-form(ref="contact" autocomplete="off" v-model="contact")
                            v-autocomplete(autocomplete="nada" dense :loading="companiesLoading" :search-input.sync="companiesSearch" :allow-overflow="false" :menu-props="{'maxHeight': 240}" :rules="companyRules" hide-details="auto" hide-no-data outlined background-color="white" color="indigo darken-1"  v-model="company" :items="companies" filled item-text="name" item-value="cid" clearable  label="Company" class="pt-0 pb-2" )
                            v-row(no-gutters)
                                v-col(class="pr-1")
                                    v-text-field(dense autocomplete="nada" :rules="nameRules"  hide-details="auto" outlined background-color="white" color="indigo darken-1" v-model="name" label="Name"  required class="pb-2")
                                v-col(class="pl-1")
                                    v-text-field(dense autocomplete="nada" :rules="lastNameRules"  hide-details="auto" outlined background-color="white" color="indigo darken-1" v-model="lastName" label="Last name"  required class="pb-2")
                            v-autocomplete(dense autocomplete="nada" hide-details="auto" outlined  :menu-props="{'maxHeight': 140}" background-color="white" color="indigo darken-1"  v-model="position" :items="positions" filled item-text="POSITION" item-value="ID" clearable  label="Position" class="pt-0 pb-2" )
                            v-text-field(dense autocomplete="nada" :rules="emailRules"  hide-details="auto" outlined background-color="white" color="indigo darken-1" v-model="email" label="Email"  required class="pb-2")
                            v-text-field(dense autocomplete="nada" :rules="phoneRules"  hide-details="auto" outlined background-color="white" color="indigo darken-1" v-model="phone" label="Phone"  required class="pb-2")

        v-row(no-gutters class="align-self-end tw-bg-white tw-border tw-rounded-b")
            v-col( class=" tw-text-right mx-2")
                v-btn( small bottom retain-focus-on-click text @click="cancel()") Cancel
                v-btn(  depressed retain-focus-on-click color="indigo darken-1" class="white--text font-weight-bold" @click="createContact") Create

        // Dialogs
        v-dialog( v-model="loading" persistent no-click-animation )
            v-card( color="primary")
                v-card-text(class=" pt-2 pb-2 tw-pl-2 tw-text-sm white--text text--accent-5 ") Hold tight...
                v-progress-linear(indeterminate color="white")
        
        v-dialog(v-model="success" persistent no-click-animation @click:outside="closeSuccess()" )
            v-card( color="green lighten-1" :ripple="false" @click="closeSuccess()"  )
                v-row(align="center" justify="center")
                    v-col(cols="auto")
                        div( class="tw-text-lg tw-font-medium white--text text--lighten-4")
                            |Got it!
                        div( class=" tw-text-center")
                            v-icon(color="white" x-large class="tw-align-center" ) mdi-check-circle-outline

        v-dialog(v-model="error" persistent no-click-animation @click:outside="closeError()" )
            v-card( color="red lighten-1" @click="closeError" :ripple="false"  )
                v-row(align="center" justify="center")
                    v-col(cols="auto")
                        div( class="tw-text-lg tw-font-medium white--text text--lighten-4")
                            |oops, sorry!
                        div( class=" tw-text-center tw-leading-none")
                            v-icon(color="white" x-large class="tw-align-center" ) mdi-crown
                        div( class=" tw-text-center tw-text-sm white--text tw-font-semibold tw-leading-none tw-tracking-widest")
                            |KEEP <br> CALM
                        div( class="tw-text-center tw-text-xs white--text tw-leading-tight")
                           |AND
                        div( class="tw-text-center tw-text-sm white--text tw-font-semibold tw-leading-none tw-tracking-widest")
                            |TRY <br>AGAIN

</template>

<script>
export default {
    data(){
        return{
            contact: false,

            //Contact Person Fields
            name:'',
            lastName: '',
            email: '',
            phone: '',
            position: '',
            company: '',

            // Lists
            positions: [],
            companies: [],
            companiesLoading: false,
            companiesSearch: null,

            // Dialogs
            loading: false,
            error: false,
            success: false,

            companyRules: [ 
                v => !!v || 'We need to select a company'
            ],

            nameRules:[
                v => !!v || 'Add a first name' 
            ],

            lastNameRules:[
                v => !!v || 'Add a last name' 
            ],

            phoneRules: [
                v => !v || /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/.test(v) || 'Enter a valid phone'
            ],

            emailRules:[
                v => !!v || 'Add an email',
                v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
            ],

            

        }
    },

    watch: {
        companiesSearch(searchString){
            this.searchCompanies(searchString)            
        }
    },

    mounted() {
        if(Object.keys(this.positions).length == 0){
            this.getPositions()
        }
        this.email = this.$route.params.requester.email
    },

    methods: {
        cancel(){
            this.$router.go(-1)
        },

        getPositions(){
            this.$http.get(this.$api_url + 'contact/positions/all', {
                headers: {
                'OAuth-Token': this.$store.getters.token
                }
            })
            .then(response => {
                this.positions = response.data
            })
            .catch(error => {
                console.log(error)
            })
        },
        
        createContact(){
            this.$refs.contact.validate()
            if(this.contact){
                this.loading = true
                const headers = {
                    'Content-Type': 'application/json',
                    'OAuth-Token': this.$store.getters.token 
                }
                this.$http.post(this.$api_url + 'contact/create', {
                    cid: this.company,
                    firstName: this.name,
                    lastName: this.lastName,
                    position: this.position,
                    email: this.email,
                    phone: this.phone
                }, {headers: headers})
                .then(response => {
                    this.loading = false
                    this.success = true
                    this._.delay( wait => {
                        this.success = false
                        this.$router.go(-1)
                    }, 3000)
                })
                .catch(error => {
                    console.log(error)
                    this.loading = false
                    this.error = true
                })

            }
            
        },

        closeSuccess(){
            this.success = false
            this.$router.go(-1)
        },

        closeError(){
            this.error = false
        },

        searchCompanies: _.debounce(function(searchString){
            const headers = {
                'Content-Type': 'application/json',
                'OAuth-Token': this.$store.getters.token 
            }
            if (searchString && searchString.length > 1){
                    this.companiesLoading = true
                    this.$http.post(this.$api_url + 'companies/search' , {
                            searchString: searchString
                        }, { headers: headers })
                        .then(response => {
                            this.companies = response.data
                            this.companiesLoading = false
                        })
                        .catch(error => {
                            console.log(error)
                            this.companiesLoading = false
                    })
                }
        }, 900)

    }
}
</script>

<style lang="stylus">
.v-btn:before {
  display: none;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0px;
    margin: 0px;

}
#createOpportunity .v-application .py-2 {
    padding-top: 0px !important;
}
</style>